import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { Pos } from '../enums/pos.enum';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service'; // Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  private apiURL: string = '';
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private errorHandler: ErrorHandlerService, // Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.env = this.appConfig.getEnvironmentNew();
  }

  getInvoice(jobCardID: string, getFromPOS: boolean) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/ServiceRequest/' +
        jobCardID +
        '/GetInvoice?getFromPOS=' +
        getFromPOS,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getInventory(jobCardID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + '/api/ServiceRequest/' + jobCardID + '/GetInventory',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveInvoice(data: any, sendToPOS: boolean) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Invoice?sendToPOS=' + sendToPOS,
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveInvoiceZA(data: any, sendToPOS: boolean) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.appConfig.getEnvironmentZA() +
        '/api/Invoice?sendToPOS=' +
        sendToPOS,
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError('Error sending to POS');
        }),
      );
  }

  updateProductToGearLinks(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Invoice/UpdateProductToGearLinks',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateProductsToGearLinks(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Invoice/UpdateProductsToGearLinks',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getDiscounts(PartnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/v4.0/Portal/${PartnerID}/Discounts?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  sendInvoiceToPOSAsSalesOrder(invoiceID, productIDs = null) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .post(
        this.appConfig.getPOSEnvironment().url +
        `/${this.helpersService.getPartnerId()}/invoices/${invoiceID}/salesOrder${productIDs ? '?ProductIDs=' + productIDs : ''}`,
        null,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  updateLineItemPricesByGroup(invoiceID: string, group: string) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    let data = { GroupID: group };
    return this.http
      .put(
        this.appConfig.getPOSEnvironment().url +
        `/${this.helpersService.getPartnerId()}/invoices/${invoiceID}/groups`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  getItemPricesGroups(partnerID: string) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url +
        `/${this.helpersService.getPartnerId()}/products/groups`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  getInvoiceV2(jobcardID, getInventory: boolean = false) {
    if (
      this.helpersService.getPartnerData().POSSystemID <= 10 ||
      getInventory == false
    ) {
      let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
      return this.http
        .get(
          this.apiURL +
          `/api/Invoice/v2/${jobcardID}?getInventory=${getInventory}`,
          requestOptions,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: any) => {
            return throwError(res.json());
          }),
        );
    } else {
      var headers = this.helpersService.getPOSApiHeaders(
        this.appConfig.getPOSEnvironment().key,
      );
      return this.http
        .get(
          this.appConfig.getPOSEnvironment().url +
          `/${this.helpersService.getPartnerId()}/products/invoices/${jobcardID}`,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((error: Response) => {
            return throwError(error);
          }),
        );
    }
  }

  UpdateInvoiceLineItemNote(lineItem) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .put(this.apiURL + `/api/Invoice/LineItem/Note`, lineItem, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  manageInvoicePOSExtras(invoiceID) {
    if (this.helpersService.getPartnerData().POSSystemID <= 10) {
      let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
      return this.http
        .get(
          this.apiURL + `/api/Invoice/ManagePOSExtras/${invoiceID}`,
          requestOptions,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: any) => {
            return throwError(res.json());
          }),
        );
    } else {
      var headers = this.helpersService.getPOSApiHeaders(
        this.appConfig.getPOSEnvironment().key,
      );
      return this.http
        .post(
          this.appConfig.getPOSEnvironment().url +
          `/${this.helpersService.getPartnerId()}/invoices/${invoiceID}/adjustments`,
          null,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((error: Response) => {
            return throwError(error);
          }),
        );
    }
  }

  sendInvoiceToPOS(invoiceID, productIDs = null) {
    if (this.helpersService.getPartnerData().POSSystemID <= 10) {
      let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
      return this.http
        .get(
          this.apiURL +
          `/api/Invoice/SendToPOS/${invoiceID}${productIDs ? '?ProductIDs=' + productIDs : ''}`,
          requestOptions,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: any) => {
            this.errorHandler.showError(
              res,
              'Failed to send the invoice to your POS',
            );
            return throwError(res.json());
          }),
        );
    } else {
      var headers = this.helpersService.getPOSApiHeaders(
        this.appConfig.getPOSEnvironment().key,
      );
      return this.http
        .post(
          this.appConfig.getPOSEnvironment().url +
          `/${this.helpersService.getPartnerId()}/invoices/${invoiceID}${productIDs ? '?ProductIDs=' + productIDs : ''}`,
          null,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: any) => {
            this.errorHandler.showError(
              res,
              'Failed to send the invoice to your POS',
            );
            return throwError(res);
          }),
        );
    }
  }

  addLineItem(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/api/Invoice/LineItem', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateLineItem(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .put(this.apiURL + '/api/Invoice/LineItem', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  deleteLineItem(invoiceID, lineItemID) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .delete(
        this.apiURL + `/api/Invoice/LineItem/${invoiceID}/${lineItemID}`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getPaymentHistory(partnerID, serviceID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Service/${serviceID}/PaymentHistory?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  refundStripePayment(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Services/StripePayment/Refund?code=${this.env.key}`, data, headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  addProductCollection(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/ProductCollection/Create?code=${this.env.key}`, data, headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  addProductCollectionLink(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/ProductCollections/LinkProduct?code=${this.env.key}`, data, headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
  
  deleteProductCollectionLink(partnerID: number, productCollectionLinkID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/Bikeshop/Partner/${partnerID}/ProductCollections/DeleteLinkedProduct/${productCollectionLinkID}?code=${this.env.key}`, headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getProductCollections(partnerID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/ProductCollections?code=${this.env.key}`, headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

    getProductCollectionData(partnerID: number, productCollectionID : number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/ProductCollectionData/${productCollectionID}?code=${this.env.key}`, headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

}
